import { render, staticRenderFns } from "./AddLeaverRule.vue?vue&type=template&id=b69196ae&"
import script from "./AddLeaverRule.vue?vue&type=script&lang=ts&"
export * from "./AddLeaverRule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports